<template>
  <div class="salaryreports__report__view">
    <div class="reports__subheader">

      <div class="schedule__daynavigator">
        <day-select-dropdown :selectedDate="getFromDate" @date-selected="(value) => setFromDate(value)" mode="day">
          <template #trigger="{ toggleDropdown, selectedDate }">
            <a
              tooltiptext
              tabindex="0"
              class="this-week-button test-this-week control-button"
              @click="toggleDropdown"
            >
              <span class>
                <span v-if="(selectedDate)" class="control-button-text">{{ formatDate(selectedDate) }}</span>
              </span>
            </a>
          </template>
        </day-select-dropdown>
      </div>
      <employees-panel
        @employeeNumberChanged="(value) => setEmployeeNumber(value)"
        :employeeNumber="salaryReportFilterEmployeeNumber"
        v-if="isAdmin"
      >
      </employees-panel>
      <b-field label="Chr" class="chr">
        <region-dropdown :sourceList="getFilters"
                        @selectionChanged="(arg) => { setFilter(arg); }"
                        :keyPropertyName="(o) => o.id"
                        :displayPropertyName="(o) => o.name"
                        :selectedValue="filter"> <!-- v-bind:value="region" -->
        </region-dropdown>
      </b-field>
      <submit-panel @submit="performLookup"> </submit-panel>
    </div>
    
    <div class="wrapper">
      <div style="text-align: left; margin-left: 0px;border-bottom: 1px solid darkgray;margin-top: 20px; height: 35px;">
        <h3 v-if="hasData" class="inline font-bold" >
          HandyVik
        </h3>
        <h3 v-if="!hasData" class="inline font-bold" >
          Ingen data
        </h3>
      </div>    
      
      <table style="width: 100%;" v-if="getDayReport && getDayReport.partialSumRows">
        <tbody v-for="row in getDayReport.partialSumRows" :value="row.value" :key="row.value">
          <tr v-show="((row.total && row.total !== 0)) && row.identifier !== 'Total'">
            <td class="row-name" style="text-align: left;width:400px;">
              <span>{{ row.reportRowName }} </span>
            </td>
            <td style="text-align: right; width: 55px;padding: 0px 5px">
              <span>{{ row.isMinutes && row.minutes ? row.minutes : row.times }}</span>
            </td>
            <td style="text-align: left; width: 55px; padding: 0px 5px 0px 0px">
              <span>{{ row.type }} </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>    
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment, { ISO_8601 } from "moment";
import APISTATE from "@/enums/APISTATE";
import DaySelectDropdown from '@/components/common/DaySelectDropdown.vue';
import RegionDropdown from '@/components/scheduler/schedule/controls/RegionDropdown.vue';
import EmployeesPanel from "@/components/report/EmployeesPanel.vue";
import SubmitPanel from "@/components/report/SubmitPanel.vue";

export default {
  name: "salary-day-report-view",
  components: { DaySelectDropdown,RegionDropdown, EmployeesPanel, SubmitPanel },
  data: () => ({
    fromDate: new Date(),
    filter: 'Alle',
    filters: [{id: 'Alle', name: 'Alle'}],
    showYear: false
  }),
  props: {},
  async mounted() {
    this.fromDate = moment(new Date()).toDate();
    const number = this.currentUser.number.toString();
    if(number === '1010' || number === '1011' || number === '1012' || number === '4077' || number === '6046' || this.currentUser.isSalaryReportOpen) {
      //alert('Løn rapport preview');
    } else {
      this.$router.push("/reports");
    }
  },
  methods: {
    ...mapActions("salaryReportStore", [
      "getAllSalaryReport",
      "getSalaryDayReport",
      "initYearMonth",
      "setMonth",
      "setYear",
      "setEmployeeNumber",
    ]),
    setFilter(arg) {
      this.filter = arg?.id ?? arg;
    },
    setFromDate(arg) {
      this.fromDate = moment(arg).toDate();
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    getDateFromMonthYear(day, month, year) {
      let date = new Date();
      date.setMonth(month);
      date.setFullYear(year);
      date.setDate(day);
      return date;
    },
    getLatestDayOfMonth(month, year) {
      return new Date(year, month + 1, 0).getDate();
    },
    testDate() {
      return {
        fromDate: this.getDateFromMonthYear(1, 11, 2021),
        toDate: this.getDateFromMonthYear(
          this.getLatestDayOfMonth(11, 2021),
          11,
          2021
        ),
      };
    },
    async performLookup() {
      const fromDate = this.fromDate;
      
      let number = this.salaryReportFilterEmployeeNumber;
      if (!number || number.toString() === '0') {
        number = this.currentUser.number;
      }
      
      const dto = {
        assistantNumber: number,
        fromDate: fromDate
      };
      await this.getSalaryDayReport(dto);
      this.filters = this.filters.filter(o => o.id !== 'Alle');
    },
    console(d) {
      console.log(d);
    },
  },
  computed: {
    ...mapGetters("salaryReportStore", [
      "salaryReportFilterEmployeeNumber",
      "salaryReportFilterMonth",
      "salaryReportFilterYear",
      "salaryReportApiState",
      "salaryDayReportList"
    ]),
    ...mapGetters(["currentUser", "isAdmin"]),
    loading() {
      return this.salaryReportApiState === APISTATE.LOADING;
    },
    getFromDate() {
      return this.fromDate;
    },
    getFilters() {      
      let filters = this.filters.filter(o => o.id === 'Alle');

      if(this.salaryDayReportList && this.salaryDayReportList.length > 1) {        
        this.salaryDayReportList?.forEach(item => {
          if(!filters.find(o => o.id === item.herdNumber)) {
            filters.push({id: item.herdNumber, name: item.herdNumber});
          }
        });
      }
      return filters;
    },
    getDayReport() {
      if(this.salaryDayReportList && this.salaryDayReportList.length > 1) {
        const data = this.salaryDayReportList.filter(f => f.herdNumber === this.filter);
        if(data && data.length > 0) {
          return data[0].reportTable;
        }
      }

      return this.salaryDayReportList;
    },
    hasData() {
      return this.salaryDayReportList && this.salaryDayReportList.length > 1;
    }
  },
};
</script>

<style lang="scss">
.schedule__daynavigator {    
  top: 18px;
  position: relative;
  .dayselectdropdown {
    .dayselectdropdown__dropdown {
      right: -170px !important;

      .dayselectdropdown__dayspanel {
        box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
      }      
    }
  }

}
.schedule__daynavigator > .dayselectdropdown > .dayselectdropdown__dropdown {
  right: -170px !important;
}
.control-button {    
  width: 120px;
  background: #adadad;
  border: 1px solid #bbb;
  border-radius: 3px;
  color: white;
  cursor: pointer;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 29px;
  line-height: 27px;
  text-align: center;
  text-decoration: none;
}

.upload-button{
  display: flex;
  align-items: flex-end;
  padding-bottom: 4px;
}

input[type=number]{
  max-width: 100px;
  border-radius: 5px;
  padding: 2px 3px;
}

.salaryreports__report__view{
  background: #d3d3d34a;
}

.wrapper {
  max-width: 800px;
  margin: auto 25%;
  background: white;
  padding: 10px;
  height: 100vh;
}
td, th {
  font-size: 12px;
  height: 28px;
}
@media print {

.wrapper {
  max-width: 100%;
  margin: auto auto;
}

.no-print {
  display: none;
}

.row-name{
  width: 55% !important;
}
}
.table-header-container {
  text-align: left; 
  margin-left: 0px;
  font-weight: bold;
  border-bottom: 1px solid darkgray;
  margin-top: 20px; 
  height: 35px;
}

.inline {
  display: inline-block;
}

.font-bold{
  font-weight: bold;
}
</style>